module.exports = __webpack_public_path__ + "static/media/Growing tray for microgreens or Fodder tray1.d4103b08.webp";